/**
 * i18next configuration — bilingual English + Arabic with browser detection.
 * The detected language drives both translation lookup and the `<html dir>` attribute.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '@/i18n/en.json';
import ar from '@/i18n/ar.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'tlc-lang',
      caches: ['localStorage'],
    },
  });

/**
 * Side-effect: keep <html lang> and <html dir> in sync with the active language.
 */
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
});
// Apply on initial load
document.documentElement.lang = i18n.language || 'en';
document.documentElement.dir = (i18n.language || 'en') === 'ar' ? 'rtl' : 'ltr';

export default i18n;
